<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">لیست تخفیف های وفاداری</h1>
          <b-row>

            <b-col cols="12">
              <div
                class="d-flex flex-column flex-wrap flex-md-row align-items-center ignore-box-sizing"
              >
                <b-form-group
                  class="d-inline-block w-24 filters-width mr-md-2"
                  label="جستجوی عنوان"
                  label-for="searchCommand"
                >
                  <b-form-input
                    id="searchCommand"
                    v-model="discountFilters.title"
                    class="d-inline-block"
                    placeholder="تخفیف چهار هفته..."
                    @keydown.enter="setPageNumberAndGetAllDiscounts"
                  />
                </b-form-group>
                <b-form-group
                  class="d-inline-block w-24 filters-width mr-md-2"
                  label="مقدار درصد"
                  label-for="percent"
                >
                  <b-form-input
                    id="percent"
                    v-model="discountFilters.percent"
                    placeholder="4"
                    @keydown.enter="setPageNumberAndGetAllDiscounts"
                  />
                </b-form-group>
                <b-form-group
                  class="d-inline-block w-24 filters-width mr-md-2"
                  label="جستجوی هفته"
                  label-for="week"
                >
                  <b-form-input
                    id="week"
                    v-model="discountFilters.week"
                    class="d-inline-block"
                    placeholder="4"
                    @keydown.enter="setPageNumberAndGetAllDiscounts"
                  />
                </b-form-group>
                <b-form-group
                  class="d-inline-block w-24 filters-width mr-md-2"
                  label="وضعیت تخفیف"
                  label-for="isActive"
                >
                  <b-form-select
                    id="isActive"
                    v-model="discountFilters.isActive"
                    :options="isActiveStatuses"
                  ></b-form-select>
                </b-form-group>
                <price-category-picker
                  :defaultPriceCategoryIds="discountFilters.priceCategoryId"
                  @getPriceCategory="setPriceCategory"
                  class="w-24 filters-width d-inline-block"
                ></price-category-picker>
                <b-button
                  variant="primary"
                  class="ml-1 mb-2 mb-md-0"
                  @click="setPageNumberAndGetAllDiscounts"
                >
                  اعمال
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-table
                ref="refUserListTable"
                class="position-relative"
                :items="discountsList"
                responsive
                :fields="myTableColumns"
                primary-key="id"
                show-empty
                bordered
                striped
                empty-text="موردی موجود نیست!"
              >
                <template #cell(isActive)="data">
                  <b-badge
                    class="font-weight-normal"
                    :variant="data.item.isActive ? 'success' : 'danger'"
                  >
                    {{ data.item.isActive ? "فعال" : "غیر فعال" }}
                  </b-badge>
                </template>
                <template #cell(colorCode)="data">
                  <div
                    class="colorCode"
                    :style="`background-color: ${data.item.colorCode}`"
                  ></div>
                </template>
                <template #cell(percent)="data">
                  {{ data.item.percent }}%
                </template>
                <template #cell(actions)="data">
                  <div class="d-flex align-items-center">
                    <b-link
                      :to="`/apps/loyalty-discount/${data.item.id}`"
                      class="mr-2"
                    >
                      <feather-icon
                        class="text-primary"
                        icon="EditIcon"
                        size="20"
                      />
                    </b-link>
                    <div
                      style="cursor: pointer"
                      @click="renderDeleteConfirmation(data.item)"
                      v-b-modal.modal-delete
                    >
                      <feather-icon
                        class="text-danger"
                        icon="Trash2Icon"
                        size="20"
                      />
                    </div>
                  </div>
                </template>
              </b-table>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
            >
              <b-pagination
                v-model="discountFilters.pageNumber"
                :total-rows="totalCount"
                :per-page="discountFilters.take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    style="transform: rotate(180deg)"
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      title="حذف تخفیف وفاداری"
      id="modal-delete"
      centered
      ok-title="بله"
      cancelTitle="خیر"
      @ok="deleteADiscount"
    >
      <b-container>
        <span v-if="tempScheduleLoyaltyDiscount">
          آیا از حذف کردن تخفیف {{ tempScheduleLoyaltyDiscount.title }} با درصد
          {{ tempScheduleLoyaltyDiscount.percent }} در هفته
          {{ tempScheduleLoyaltyDiscount.week }} اطمینان دارید ؟
        </span>
      </b-container>
    </b-modal>
  </b-overlay>
</template>

<script>
export default {
  mounted() {
    this.getAllDiscountsList();
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllDiscountsList();
      },
    },
  },
  data() {
    return {
      isLoading: false,
      discountsList: null,
      discountFilters: {
        priceCategoryId: null,
        title: null,
        percent: null,
        isActive: null,
        week: null,
        colorCode: null,
        pageNumber: 1,
        take: 10,
      },
      totalCount: null,
      tempScheduleLoyaltyDiscount: null,
      myTableColumns: [
        {
          key: "id",
          label: "شناسه تخفیف",
        },
        {
          key: "title",
          label: "عنوان تخفیف",
        },
        {
          key: "priceCategoryTitle",
          label: "گروه بندی تخفیف",
        },
        {
          key: "isActive",
          label: "وضعیت تخفیف",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
      isActiveStatuses: [
        {
          value: null,
          text: "همه",
        },
        {
          value: true,
          text: "فعال ها",
        },
        {
          value: false,
          text: "غیر‌فعال ها",
        },
      ],
    };
  },
  methods: {
    renderDeleteConfirmation(scheduleLoyaltyDiscount) {
      this.tempScheduleLoyaltyDiscount = JSON.parse(
        JSON.stringify(scheduleLoyaltyDiscount)
      );
    },
    setPriceCategory(priceCategoryId) {
      this.discountFilters.priceCategoryId = priceCategoryId;
    },
    setPageNumberAndGetAllDiscounts() {
      this.discountFilters.pageNumber = 1;
      this.getAllDiscountsList();
    },
    async deleteADiscount() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteAScheduleLoyaltyDiscount = new DeleteAScheduleLoyaltyDiscount(
          _this
        );
        deleteAScheduleLoyaltyDiscount.setRequestParam({
          id: _this.tempScheduleLoyaltyDiscount.id,
        });
        await deleteAScheduleLoyaltyDiscount.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "Trash2Icon",
                variant: "success",
                text: "تخفیف با موفقیت حذف شد.",
              },
            });
            _this.getAllDiscountsList();
            _this.tempScheduleLoyaltyDiscount = null;
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "Trash2Icon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllDiscountsList() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllDiscounts = new GetAllScheduleLoyaltyDiscounts(_this);
        getAllDiscounts.setRequestParamDataObj(_this.discountFilters);
        await getAllDiscounts.fetch((res) => {
          _this.discountsList = res.data;
          _this.totalCount = res.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    pageNumber() {
      return this.discountFilters.pageNumber;
    },
  },
  components: {
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BInputGroup,
    PriceCategoryPicker,
  },
};
import {
  GetAllScheduleLoyaltyDiscounts,
  DeleteAScheduleLoyaltyDiscount,
} from "@/libs/Api/ScheduleLoyaltyDiscount";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import PriceCategoryPicker from "@/views/apps/PriceCategory/PriceCategoryPicker.vue";
import {
  BContainer,
  BCard,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BInputGroup,
} from "bootstrap-vue";
</script>
<style scoped>
.colorCode {
  width: 4rem;
  height: 1.5rem;
  border: 1px solid #333333;
}
.ignore-box-sizing * {
  box-sizing: border-box;
}
</style>
